export * from './apartment-skeleton';
